const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cats API
export const catsAPI = {
  getAll: async () => {
    const response = await fetch(`${API_URL}/api/cats`);
    if (!response.ok) throw new Error('Failed to fetch cats');
    return response.json();
  },
  
  getByCategory: async (category) => {
    const response = await fetch(`${API_URL}/api/cats/category/${category}`);
    if (!response.ok) throw new Error(`Failed to fetch ${category} cats`);
    return response.json();
  },
  
  getById: async (id) => {
    const response = await fetch(`${API_URL}/api/cats/${id}`);
    if (!response.ok) throw new Error('Failed to fetch cat');
    return response.json();
  }
};

// Awards API
export const awardsAPI = {
  getAll: async () => {
    const response = await fetch(`${API_URL}/api/awards`);
    if (!response.ok) throw new Error('Failed to fetch awards');
    return response.json();
  },
  
  getByYear: async (year) => {
    const response = await fetch(`${API_URL}/api/awards/year/${year}`);
    if (!response.ok) throw new Error(`Failed to fetch ${year} awards`);
    return response.json();
  },
  
  // Group awards by year
  getAllGroupedByYear: async () => {
    const awards = await awardsAPI.getAll();
    const grouped = {};
    
    awards.forEach(award => {
      if (!grouped[award.year]) {
        grouped[award.year] = [];
      }
      grouped[award.year].push(award);
    });
    
    return grouped;
  }
};

// Instagram API
export const instagramAPI = {
  getFeed: async () => {
    const response = await fetch(`${API_URL}/api/instagram-feed`);
    if (!response.ok) throw new Error('Failed to fetch Instagram feed');
    return response.json();
  }
};
